import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { route } from "../../routes/routes"
import { t } from "i18next";

const user = JSON.parse(localStorage.getItem("stt"));

export const items = route
  .filter(d => d.showMenu !== false) // กรองเส้นทางที่ showMenu เป็น false
  .map((d) => {
    if (user) {
      const res = d.access.filter((acc) => {
        if (acc === user.role){
          return d
        }
        });

      if (res.length !== 0) {
        if (d.routes) {
          return {
            label: d.name,
            key: d.path,
            icon: <SettingOutlined />,
            access: d.access,
            children: d.routes
              .filter(child => child.showMenu !== false) // กรองเส้นทางลูกที่ showMenu เป็น false
              .map((child) => ({
                label: child.name,
                key: d.path + child.path,
                icon: <SettingOutlined />,
                path: d.path + child.path,
              })),
          };
        } else {
          return {
            label: d.name,
            key: d.path,
            icon: d.icon,
            path: d.path,
            access: d.access,
          };
        }
      }
    }
    return null;
  })
  .filter(item => item !== null);



export const getMenuSider = () => {
const user = JSON.parse(localStorage.getItem("stt"));

const res = route.map((d)=>{
  if(user){
    const res = d.access.filter((acc)=>{
      if(acc== user.role){
        return d
      }
    })
    if(res.length != 0){
    if(d.routes){
     return {
        // label: d.name,
        label:t(d.name),
        key: d.path,
        icon: <SettingOutlined />,
        access:d.access,
        children:d.routes.map((child)=>{
          if(child.showMenu){
            return{
              label: child.name,
              key: d.path+child.path,
              icon: <SettingOutlined />,
              path:d.path+child.path
            }
          }else{
            return null
          }
         
        })
      }
    }else{
      if(d.showMenu){
        return  {
          // label: d.name,
          label: t(d.name),
          key: d.path,
          icon: d.icon,
          path: d.path,
          access: d.access,
        }
      }else{
        return  null
      }
      
    }
  }else{
    return null
  }
  }else{
    return null
  }
})

const res2 = res.filter((d)=> d != null)
return res2
}
